






























import { Component, Emit, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MenuEdit extends Vue {
  private visible = false;
  private isChecked: any = '';
  private iconList: any = [];
  private activeName = 'Simple Line Icons'; // 打开弹窗默认展示的tab
  private industries: any = ['Simple Line Icons', 'Font Awesome Icons', 'Glyphicons']; // tab列展示的名称

  private mounted() {
    this.getIconJson();
  }

  /**
   * 打开窗口
   */
  private async showDialog(data: any) {
    this.isChecked = data;
    this.visible = true;
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
    this.visible = false;
  }

  /**
   * 【按钮】清除按钮点击
   */
  private clear() {
    this.isChecked = '';
  }

  /**
         @description: 改变tab头的值
         @author: cxf
         @update: cxf 2021/5/20 14:31
         **/
  private clickActive(data: any) {
    this.activeName = data.name;
  }

  /**
         @description: 点击选中的图标，将值传给父级
         @author: cxf
         @update: cxf 2021/5/20 14:31
         **/
  private clickIcon(icon: any) {
    this.isChecked = icon.name;
    this.onResponse(icon);
    this.visible = false;
  }

  /**
         @description: 点击选中的图标，将值传给父级
         @author: cxf
         @update: cxf 2021/5/20 14:31
         **/
  private clickChange(icon: any) {
    this.isChecked = icon.className;
  }

  /**
   * @desc 获取icon列表
   */
  private getIconJson() {
    fetch('icon/iconfont.json').then(res => {
      res.json().then(r => {
        this.iconList = r.glyphs.map((icon: any) => ({
          name: icon.name,
          className: `icon${icon.font_class}`,
        }));
      });
    });
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.isChecked = '';
    this.visible = false;
  }

  /**
   * 【广播】广播提交成功事件
   */
  @Emit('on-response')
  private onResponse(icon: any) {}
}
